// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#messages-column[data-v-61cd5940]{-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background-color:#fff;position:relative;min-width:320px}#messages-column .start-conversation-placeholder[data-v-61cd5940]{height:100%;font-size:40px;opacity:.5}", ""]);
// Exports
module.exports = exports;
